interface String {
	format(...args: string[]): string;
	formatWithObjects(...args: Array<Array<any> | object>): string;
	isAlphanumeric(): boolean;
}

// Extension method della classe String per la formattazione delle stringhe
String.prototype.format = function (this: string, ...args: string[]): string {
	let formatted = this;
	for (let i = 0; i < args.length; i++) {
		const regexp = new RegExp('\\{' + i + '\\}', 'gi');

		if (formatted) {
			formatted = formatted.replace(regexp, args[i]);
		}
	}
	return formatted;
};

String.prototype.formatWithObjects = function (this: string, ...params: Array<Array<any> | object>): string {
	return this.replace(/[{](.*?)[}]/g, (tag: string, innerTag: any) => {
		const tagValueContainer = params.filter((param) => (<any>param)[innerTag] != null)[0];
		return (tagValueContainer ? (<any>tagValueContainer)[innerTag] : '');
	});
};

// Extension method della classe String che controlla se la stringa è di tipo Alfanumerico
String.prototype.isAlphanumeric = function (this: string): boolean {
	const regExp = /^[0-9a-zA-Z]+$/;
	return this.match(regExp) != null;
};

namespace Seac.Commons {
	/** Utility per la gestione delle stringhe */
	export class StringUtility {
		/** Formatta la stringa per essere utilizzata in codice JavaScript all'interno di una pagina HTML */
		public static JsInHtml(x: string): string {
			if (x) {
				return x
					.replace(/'/g, '')
					.replace(/"/g, '')
					.replace(/\r|\n|\t/g, '')
				;
			}else {
				return x;
			}
		}
 
		/** Formatta la stringa per essere utilizzata in un attributo HTML */
		public static ForHtmlAttrubute(x: string): string {
			if (x) {
				return x
					.replace(/"/g, '&quot;')
			//		.replace(/\r|\n|\t/g, '')
				;
			}else {
				return x;
			}
		}
	}
}
